<div class="bg-blue persona-container">
    <apc-navbar-big [items]=navigation></apc-navbar-big>
    <div class="content">
        <apc-breadcrumbs [navigationSub]=navigation></apc-breadcrumbs>
        <router-outlet></router-outlet>
    </div>
</div>
<apc-create-element-buttons [buttons]="buttons" (createEvent)="createElement($event)"></apc-create-element-buttons>